import { ChannelData } from 'stream-chat';
import { truncate } from 'lodash';

import i18n from 'config/i18n';
import { ContentFragment } from 'api';
import { getImageUrl, getTitle } from 'features/content/helpers';
import { IMGIX_HOST } from 'settings';

const NUM_PROFILE_IMAGES = 6;
const APP_IMAGES_DIRECTORY = 'webapp';

const MAX_NAME_LENGTH = 140;

export const getChannelName = (content: ContentFragment) => {
  const title = getTitle(content);

  if (title) {
    return title;
  }

  if (content.user) {
    const { full_name } = content.user;
    return `${i18n.t('discussions:userChannel', { name: full_name })}`;
  }

  return '';
};

export const getChannelImageUrl = (content: ContentFragment) => {
  const postImage = getImageUrl(content);

  if (postImage) {
    return postImage;
  }

  if (content.user) {
    const { user } = content;
    const { image } = user;

    const index = Math.floor(Math.random() * NUM_PROFILE_IMAGES) + 1;
    const randomUrl = `${IMGIX_HOST}/${APP_IMAGES_DIRECTORY}/profile-${index}.png?w=100&h=100auto=format,compress`;
    return image ? `${IMGIX_HOST}/${image.key}?auto=format,compress` : randomUrl;
  }

  return '';
};

const configureChannel = (content: ContentFragment): ChannelData => {
  const name = getChannelName(content);
  const image = getChannelImageUrl(content);
  const formattedName =
    name.length >= MAX_NAME_LENGTH ? truncate(name, { length: MAX_NAME_LENGTH }) : name;

  return {
    image,
    name: formattedName,
    internalType: 'post',
  };
};

export default configureChannel;
